import { baseApi } from './baseApi'
import type { RulesRes, RuleReq } from '../../types'

export const rulesApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getRules: builder.query<RulesRes, void>({
			query: () => ({
				url: '/rules',
				method: 'GET',
			}),
			providesTags: ['Rule'],
		}),

		postRule: builder.mutation<{ message?: string; data?: unknown }, RuleReq>({
			query: (data) => ({
				url: '/rules',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Rule'],
		}),

		deleteRule: builder.mutation<{ message?: string }, RuleReq>({
			query: (data) => ({
				url: '/rules',
				method: 'DELETE',
				body: data,
			}),
			invalidatesTags: ['Rule'],
		}),
	}),
})

export const {
	useGetRulesQuery,
	usePostRuleMutation,
	useDeleteRuleMutation,
} = rulesApi

